import React from "react";
import { Link } from "react-router-dom";

const E404 = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center position-relative"
      style={{
        minHeight: "100vh",
        background: "#f8f9fb",
        overflow: "hidden",
        padding: "20px",
      }}
    >
      {/* Background 404 */}
      <div
        style={{
          position: "absolute",
          fontSize: "clamp(120px, 20vw, 420px)", // 🔥 responsive scaling
          fontWeight: "700",
          color: "#e9ecf2",
          letterSpacing: "clamp(5px, 1vw, 20px)",
          userSelect: "none",
          whiteSpace: "nowrap",
        }}
      >
        404
      </div>

      {/* Content */}
      <div
        className="text-center"
        style={{
          zIndex: 2,
          maxWidth: "420px",
          width: "100%",
        }}
      >
        <h4
          className="fw-semibold mb-2"
          style={{ fontSize: "clamp(18px, 2vw, 28px)" }}
        >
          Page not found
        </h4>

        <p
          className="text-muted mb-4"
          style={{ fontSize: "clamp(13px, 1.2vw, 16px)" }}
        >
          The page you’re looking for doesn’t exist or has been moved.
        </p>

        <Link
          to="/"
          className="btn btn-primary px-4 shadow-sm"
          style={{
            fontSize: "clamp(13px, 1vw, 15px)",
            padding: "10px 20px",
            borderRadius: "10px",
          }}
        >
          Back to home →
        </Link>
      </div>
    </div>
  );
};

export default E404;